import React, { useState } from 'react';
import { useTranslations } from '@unisporkal/localization';

import DropdownField from '../../Controls/DropdownField';
import styles from './ProjectCodes.module.scss';
import useProjectCode from '../../../hooks/stateful/useProjectCode';
import useFormValidationError from '../../../hooks/stateful/useFormValidationError';
import useSelectedIndex from '../../../hooks/stateful/useSelectedIndex.ts';
import useOnLoad from '../../../hooks/queries/useOnLoad';
import { resolvePaProjectCodes } from '../../../shared/paProjectCode';

const resolveProjectCodeFields = (batchAgreements, selectedOption) => {
  const paAgreement = batchAgreements?.find((agreement) =>
    resolvePaProjectCodes(agreement)
  );
  const batchPaProjectCodes = paAgreement
    ? resolvePaProjectCodes(paAgreement)
    : null;
  return {
    projectCodes:
      batchPaProjectCodes?.projectCodes ?? selectedOption?.projectCodes,
    projectCodeRequired: batchPaProjectCodes
      ? batchPaProjectCodes.projectCodeRequired
      : selectedOption?.projectCodeRequired,
  };
};

const ProjectCodes = () => {
  const { selectedOption } = useSelectedIndex();
  const { formValidationError } = useFormValidationError();
  const { projectCode, setProjectCode } = useProjectCode();
  const { response: { config: { batchAgreements } = {} } = {} } = useOnLoad();

  const t = useTranslations();
  const [wasClicked, setWasClicked] = useState(false);

  const { projectCodes, projectCodeRequired } = resolveProjectCodeFields(
    batchAgreements,
    selectedOption
  );

  const agreementViewOnlyPermissions =
    !selectedOption?.effectivePermissions?.includes('Download');
  const showProjectCodes =
    projectCodes?.length > 0 && !agreementViewOnlyPermissions;

  const isValid = projectCodeRequired ? projectCode !== null : true;

  const errorMessage = () => {
    if (wasClicked ? !isValid : formValidationError) {
      return <div className={styles.alertText}>{t('enter_required_info')}</div>;
    }
    return null;
  };

  const handleOnChange = (e) => {
    setProjectCode(e.target.value);
    setWasClicked(true);
  };

  const renderProjectCodesDropdown = () => (
    <DropdownField
      id={t('project_code')}
      required={projectCodeRequired}
      onBlur={() => setWasClicked(true)}
      onChange={handleOnChange}
      defaultValue={0}
    >
      {projectCodeRequired ? (
        <option
          value={0}
          disabled
          hidden
        >
          {t('project_code_required')}
        </option>
      ) : (
        <option
          value={0}
          disabled
          hidden
        >
          {t('project_code')}
        </option>
      )}
      {projectCodes?.map((code) => (
        <option
          data-testid="project-code"
          key={code}
          value={code}
        >
          {code}
        </option>
      ))}
    </DropdownField>
  );

  if (!selectedOption) {
    return null;
  }

  if (showProjectCodes) {
    return (
      <div
        className={styles.container}
        data-testid="project-codes-container"
      >
        {errorMessage()}
        {renderProjectCodesDropdown()}
      </div>
    );
  }
  return null;
};

export default ProjectCodes;
